import { lazy } from 'react';

export const AdmsiteSettingsPageLazy = lazy(() => import('./AdmsiteSettingsPage'));
